module.exports = __webpack_public_path__ + "assets/0.jpg?a56f54c5c9249540a088ffc34f635cab";